import PropTypes from 'prop-types';
import { cx } from 'ramda-extension';

const ExtendedIcon = ({ name, className, children, ...other }) => (
	<i className={cx(`Icon Icon--${name}`, className)} {...other}>
		{children}
	</i>
);

ExtendedIcon.displayName = 'Icon';
ExtendedIcon.propTypes = {
	children: PropTypes.any,
	className: PropTypes.string,
	name: PropTypes.string,
};

export default ExtendedIcon;
